import axiosInstance from '../utils/axios';

export const getMenuAccessApi = async () => {
    const res = await axiosInstance.get('api/admin/getMenuAccessList');
    return res.data;
};

export const getBrandApi = async (payload) => {
    const res = await axiosInstance.get('api/catalog/brands', { params: payload });
    return res.data;
};

export const getBrandApiproductpage = async (payload, page) => {
    const res = await axiosInstance.get(`api/catalog/brands?search=${payload}&page=1&limit=10000000&is_active=1`);
    return res.data;
};

export const getBrandByIdApi = async (id) => {
    const res = await axiosInstance.get(`api/catalog/getBrandById/${id}`);
    return res.data;
};

export const LoginApi = async (payload) => {
    const res = await axiosInstance.post('api/auth/login', payload);
    return res.data;
};

export const RegisterApi = async (payload) => {
    const res = await axiosInstance.post('api/auth/register', payload);
    return res.data;
};
export const CPRegisterApi = async (payload) => {
    const res = await axiosInstance.post('api/auth/cp-register', payload);
    return res.data;
};
export const postBrandApi = async (payload) => {
    const res = await axiosInstance.post('api/catalog/addBrand', payload);
    return res.data;
};

export const updateBrandApi = async (payload) => {
    const res = await axiosInstance.put(`api/catalog/updateBrand/${payload.id}`, payload);
    return res.data;
};

export const updateMenuApi = async (payload) => {
    const res = await axiosInstance.put(`api/admin/updateMenu/${payload.id}`, payload);
    return res.data;
};

export const postMenuApi = async (payload) => {
    const res = await axiosInstance.post('api/admin/addMenu', payload);
    return res.data;
};


export const ImageUploadApi = async (payload) => {
    const res = await axiosInstance.post('api/upload', payload, {
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    });
    return res.data;
};

export const postCategoryApi = async (payload) => {
    const res = await axiosInstance.post('api/catalog/addCategory', payload);
    return res.data;
};

export const getCategoryApi = async (type, payload) => {
    const res = await axiosInstance.get(`api/catalog/getCategoryData/${type}`, { params: payload });
    return res.data;
};

export const getCategorybyId = async (id) => {
    const res = await axiosInstance.get(`api/catalog/getCategoryById/${id}`);
    return res.data;
};

export const updateCategoryApi = async (payload) => {
    const res = await axiosInstance.put(`api/catalog/updateCategory/${payload.id}`, payload);
    return res.data;
};

export const getAttributeApi = async (payload) => {
    const res = await axiosInstance.get(`api/catalog/getAttributes`, { params: payload });
    return res.data;
};





//saras apis

//Attribute
export const updateAttributeApi = async (payload) => {
    const res = await axiosInstance.put(`api/catalog/updateAttributeById/${payload.id}`, payload);
    return res.data;
};

export const postAttributeApi = async (payload) => {
    const res = await axiosInstance.post('api/catalog/addAttribute', payload);
    return res.data;
};

export const getAttributebyId = async (id) => {
    const res = await axiosInstance.get(`api/catalog/getAttibutebyId/${id}`);
    return res.data;
};

export const getAttributeValueList = async (id, payload) => {
    const res = await axiosInstance.get(`api/catalog/getValues/${id}`, { params: payload });
    return res.data;
};

export const postAttributeValueApi = async (payload) => {
    const res = await axiosInstance.post('api/catalog/addValues', payload);
    return res.data;
};

//User
export const getUserApi = async (payload) => {
    const res = await axiosInstance.get(`api/users/getUserList`, { params: payload });
    return res.data;
};

export const getUserApiBySearch = async (payload) => {
    const res = await axiosInstance.get(`api/users/getUserList?search=${payload}&page=1&limit=100000`);
    return res.data;
};

export const postuserApi = async (payload) => {
    const res = await axiosInstance.post(`api/users/addUser`, payload);
    return res.data;
};

export const getUserbyId = async (id) => {
    const res = await axiosInstance.get(`api/users/getUserById/${id}`);
    return res.data;
};

export const updateUserData = async (payload) => {
    const res = await axiosInstance.put(`api/users/updateUser/${payload.id}`, payload);
    return res.data;
};

//Master
export const postMasterApi = async (payload) => {
    const res = await axiosInstance.post('api/admin/addList', payload);
    return res.data;
};

export const getMasterApi = async (payload) => {
    const res = await axiosInstance.get(`api/admin/getAllLists`, { params: payload });
    return res.data;
};

export const getMasterById = async (id) => {
    const res = await axiosInstance.get(`api/admin/getListById/${id}`);
    return res.data;
};

export const updateMasterApi = async (payload) => {
    const res = await axiosInstance.put(`api/admin/updateListById/${payload.id}`, payload);
    return res.data;
};

//Variant
export const postVariantApi = async (payload) => {
    const res = await axiosInstance.post('api/catalog/addProductVariant', payload);
    return res.data;
};
export const getVariantApi = async (payload) => {
    const res = await axiosInstance.get(`api/catalog/getAllProducts`, { params: payload });
    return res.data;
};
export const getVarientAttributebyId = async (id) => {
    const res = await axiosInstance.get(`api/catalog/getAttibutebyId/${id}`);
    return res.data;
};
export const getVariantList = async (payload) => {
    const res = await axiosInstance.get(`api/catalog/getAllProducts`, { params: payload });
    return res.data;
};

export const getVarientByID = async (id) => {
    const res = await axiosInstance.get(`api/catalog/getProductVariantById/${id}`);
    return res.data;
};

export const updateVariant = async (payload) => {
    const res = await axiosInstance.post(`api/catalog/addProductVariant`, payload);
    return res.data;
};

export const getAttributeListBycategoryId = async (id) => {
    const res = await axiosInstance.get(`api/catalog/getAttributeListBycategoryId/${id}`);
    return res.data;
};

export const submitSelectedProductsApi = async (payload) => {
    const res = await axiosInstance.post('api/catalog/syncProductImages', payload);
    return res.data;
};

export const postUploadImagesApi = async (payload) => {
    const res = await axiosInstance.post('api/bulkProductImageUpload', payload, {
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    });
    return res.data;
};

//group
export const postGroupApi = async (payload) => {
    const res = axiosInstance.post('api/admin/addAuthGroups', payload);
    return res.data;
}
export const getGroupApi = async (payload) => {
    const res = await axiosInstance.get(`api/admin/getAllAuthGroups`, { params: payload });
    return res.data;
};

export const getGroupbyId = async (id) => {
    const res = await axiosInstance.get(`api/admin/getAuthGroupsById/${id}`);
    return res.data;
};

export const updateGroupApi = async (payload) => {
    const res = await axiosInstance.put(`api/admin/updateAuthGroupsById/${payload.id}`, payload);
    return res.data;
}

//Post
export const getPostApi = async (payload) => {
    const res = await axiosInstance.get(`api/post/getAllPosts`, { params: payload });
    return res.data;
};

export const postDataApi = async (payload) => {
    const res = axiosInstance.post('api/post/addPost', payload);
    return res.data;
}

export const getPostDataById = async (id) => {
    const res = await axiosInstance.get(`api/post/getPostById/${id}`);
    return res.data;
};

export const updatePostApi = async (payload) => {
    const res = await axiosInstance.put(`api/post/updatePostById/${payload.id}`, payload);
    return res.data;
}


export const getLists = async (type, payload) => {
    const res = await axiosInstance.get(`api/admin/getLists/${type}`, payload);
    return res.data;
};

export const getMasterData = async (payload) => {
    const res = await axiosInstance.get(`api/admin/getMasterList`, { params: payload });
    return res.data;
};

//rating
export const getRatingApi = async (payload) => {
    const res = await axiosInstance.get(`api/crm/getRatings`, { params: payload });
    return res.data;
};

export const updateRatingApi = async (payload) => {
    const res = await axiosInstance.post(`api/crm/RatingUpdate`, payload);
}

//Complain
export const getComplainApi = async (payload) => {
    const res = await axiosInstance.get(`api/crm/ComplaintList`, { params: payload });
    return res.data;
};
export const ComplainListApi = async (payload) => {
    const res = await axiosInstance.get(`api/crm/ComplaintList`, { params: payload });
    return res.data;
};
export const getTicketByAuditId = async (id,payload) => {
    const res = await axiosInstance.get(`api/crm/getTicketByAuditId/${id}`, { params: payload });
    return res.data;
};
export const getComplainParamApi = async (name, status, date, payload) => {
    const res = await axiosInstance.get(`api/crm/ComplaintList?name=${name}&status=${status}&date=${date}&page=1&limit=10`);
    return res.data;
};

export const postSlaApi = async (payload) => {
    const res = axiosInstance.post('api/crm/addsla', payload);
    return res;
}

export const getSlaApi = async (payload) => {
    const res = await axiosInstance.get(`api/crm/slaList`, { params: payload });
    return res.data;
};

export const getComplaintOrderApi = async (payload) => {
    const res = await axiosInstance.get(`api/order/getcomplaintOrder?search=${payload}&page=1&limit=10`);
    return res.data;
};

export const getAuthUserApi = async (payload) => {
    const res = await axiosInstance.get(`api/users/getUserList`, { params: payload });
    return res.data;
};

export const postComplainApi = async (payload) => {
    const res = axiosInstance.post('api/crm/addComplaint', payload);
    return res;
}

export const getComplaintById = async (id) => {
    const res = await axiosInstance.get(`api/crm/ComplaintbyId/${id}`);
    return res.data;
};

export const postCommentApi = async (payload) => {
    const res = axiosInstance.post('api/crm/addComments', payload);
    return res;
}


export const getCommentsApi = async (id, payload) => {
    const res = await axiosInstance.get(`api/crm/CommentsList/${id}`, { params: payload });
    return res.data;
};


export const getOrderListByCustomerApi = async (payload) => {
    const res = await axiosInstance.get(`api/order/getOrderByCustomerid`, { params: payload });
    return res.data;
};
//webfeed
export const postwebCommentApi = async (payload) => {
    const res = axiosInstance.post('api/crm/addComment', payload);
    return res;
}
export const postaddWebfeed = async (payload) => {
    const res = await axiosInstance.post('/api/crm/addWebfeed', payload);
    return res.data;
};
export const postwebfeedbyidApi = async (id) => {
    const res = await axiosInstance.get(`/api/crm/getWebfeedById/${id}`);
    return res.data;
};
export const getWebfeedCommentList = async (id) => {
    const res = await axiosInstance.get(`/api/crm/getWebfeedCommentList/${id}`);
    return res.data;
};
export const updateWebfeed = async (payload, id) => {
    const res = await axiosInstance.post(`/api/crm/updateWebfeed/${id}`, payload);
    return res.data;
};
export const getwebfeedListApi = async (payload) => {
    const res = await axiosInstance.get(`api/crm/getWebfeedList`, { params: payload });
    return res.data;
};

//Section
export const getSectionApi = async (payload) => {
    const res = await axiosInstance.get(`api/cms/getSectionList`, { params: payload });
    return res.data;
};
// export const getSectionApis = async (payload) => {
//     const res = await axiosInstance.get(`api/cms/getSectionList`, { params: payload });
//     return res.data;
// };

export const postSectionApi = async (payload) => {
    const res = axiosInstance.post('api/cms/addSection', payload);
    return res;
}

export const updateSectionApi = async (payload) => {
    const res = await axiosInstance.put(`api/cms/updateSectionById/${payload.id}`, payload);
    return res.data;
}

export const getsectionById = async (id) => {
    const res = await axiosInstance.get(`api/cms/getSectionById/${id}`);
    return res.data;
};
export const getHomeserch = async (id) => {
    const res = await axiosInstance.get(`api/cms/getPageStatus/${id}`);
    return res.data;
};
export const getSectionPageApi = async (payload) => {
    const res = await axiosInstance.get(`api/cms/getPageList`, { params: payload });
    return res.data;
};

export const postSectionPageApi = async (payload) => {
    const res = axiosInstance.post('api/cms/addSectionPage', payload);
    return res;
}
export const sectionProductList = async (id) => {
    const res = await axiosInstance.get(`api/cms/sectionProductList/${id}`);
    return res.data;
};

export const getBannerApi = async (payload) => {
    const res = await axiosInstance.get(`api/cms/getBannerList`, { params: payload });
    return res.data;
};

export const postBannerApi = async (payload) => {
    const res = axiosInstance.post('api/cms/addBanner', payload);
    return res;
}

export const getPagesById = async (id) => {
    const res = await axiosInstance.get(`api/cms/getPageById/${id}`);
    return res.data;
};


export const getBannerById = async (id) => {
    const res = await axiosInstance.get(`api/cms/getBannerById/${id}`);
    return res.data;
};

export const updateBannerApi = async (payload) => {
    const res = await axiosInstance.put(`api/cms/updateBannerById/${payload.id}`, payload);
    return res.data;
}

//Dashboard

export const getOrderCommentById = async (id, payload) => {
    const res = await axiosInstance.get(`api/order/getorderHistoryById/${id}`, { params: payload });
    return res.data;
};

export const getdashboardComplaintApi = async (payload) => {
    const res = await axiosInstance.get(`api/dashboard/dashboardComplaintsList?search=${payload}&page=1&limit=10`);
    return res.data;
};

export const getdashboardOrderApi = async (payload) => {
    const res = await axiosInstance.get(`api/dashboard/dashboardOrderList?search=${payload}&page=1&limit=10`);
    return res.data;
};

export const getdashboardProductApi = async (payload) => {
    const res = await axiosInstance.get(`api/dashboard/dashboardProductList?search=${payload}&page=1&limit=10`);
    return res.data;
};






//vendor product
export const getVendorProductApi = async (payload) => {
    const res = await axiosInstance.get(`api/catalog/vendor/allProduct`, { params: payload });
    return res.data;
};

export const postApproveProductApi = async (payload) => {
    const res = axiosInstance.post('api/catalog/vendor/approveProducts', payload);
    return res;
}

export const postRejectedProductApi = async (payload) => {
    const res = axiosInstance.post('api/catalog/vendor/rejectProducts', payload);
    return res;
}
//vendor Settlement
export const vendorListApi = async (id) => {
    const res = await axiosInstance.get(`api/admin/vendorList?limit=10000&&country_id=${id}`,);
    return res.data;
};
export const getOrderListbyVendoridApi = async (payload) => {
    const res = await axiosInstance.get(`api/order/getOrderList`, { params: payload });
    return res.data;
};
export const ledgerList = async (payload) => {
    const res = await axiosInstance.get(`api/admin/ledgerList`, { params: payload });
    return res.data;
};
export const vendorsettleStatusUpdate = async (payload) => {
    const res = await axiosInstance.post('/api/admin/vendorSettle', payload);
    return res.data;
};


//vendor country
export const postVendorCountryApi = async (payload) => {
    const res = await axiosInstance.post('/api/admin/addVendorarea', payload);
    return res.data;
};

export const postVendorCommissionApi = async (payload) => {
    const res = await axiosInstance.post('/api/admin/addVendorCommission', payload);
    return res.data;
};

export const getvendorcountryList = async (payload) => {
    const res = await axiosInstance.get('api/admin/vendorAreaList', { params: payload });
    return res.data;
};

export const getvendorCommissionListApi = async (payload) => {
    const res = await axiosInstance.get('api/admin/vendorCommissionList', { params: payload });
    return res.data;
};

export const updateVedorCountryApi = async (payload) => {
    const res = await axiosInstance.put(`api/admin/updatevendorCountery/${payload.id}`, payload);
    return res.data;
};

//murali apis
export const getMenuListApi = async (payload) => {
    const res = await axiosInstance.get('api/admin/getMenuList', { params: payload });
    return res.data;
};

export const getsubmenuListApi = async (payload) => {
    const res = await axiosInstance.get('api/admin/getsubmenuList', { params: payload });
    return res.data;
};

export const getMenuByIdApi = async (id) => {
    const res = await axiosInstance.get(`api/admin/getMenuById/${id}`);
    return res.data;
};
export const getGroupMenuAccessListApi = async (id) => {
    const res = await axiosInstance.get(`api/admin/getGroupMenuAccessList/${id}`);
    return res.data;
};

export const changeMenuDisplayApi = async (payload) => {
    const res = await axiosInstance.post('/api/admin/changeMenuDisplay', payload);
    return res.data;
};
export const updatemenudisplayApi = async (payload) => {
    const res = await axiosInstance.post('/api/admin/updatemenudisplay', payload);
    return res.data;
};



//vamsi apis

export const getVendorApi = async (payload) => {
    const res = await axiosInstance.get(`api/admin/vendorList`, { params: payload });
    return res.data;
};

export const updateVendorApi = async (payload) => {
    const res = await axiosInstance.put(`api/admin/updateVendor/${payload.id}`, payload);
    return res.data;
};

export const postVendorApi = async (payload) => {
    const res = await axiosInstance.post("api/admin/addVendor", payload);
    return res.data;
};

export const getVendorByIdApi = async (id) => {
    const res = await axiosInstance.get(`api/admin/getVendorById/${id}`);
    return res.data;
};

export const changePasswordApi = async (payload) => {
    const res = await axiosInstance.post('/api/auth/authModal/change-password', payload)
    return res.data
}

//customerapis
export const postCustomerApi = async (payload) => {
    const res = await axiosInstance.post('/api/admin/addCustomer', payload);
    return res.data;
};
export const postaddAddressApi = async (payload) => {
    const res = await axiosInstance.post('/api/admin/addAddress', payload);
    return res.data;
};
export const postaddcustomercommentApi = async (payload) => {
    const res = await axiosInstance.post('/api/admin/addCustomerComment', payload);
    return res.data;
};

export const getCustomerListapi = async (payload) => {
    const res = await axiosInstance.get(`api/admin/getCustomerList`, { params: payload });
    return res.data;
};
export const getCustomerListTicket = async (value) => {
    const res = await axiosInstance.get(`api/admin/getCustomerList?limit=10000&&search=${value}`);
    return res.data;
};
export const getCartListapi = async (payload) => {
    const res = await axiosInstance.get(`api/admin/getCartList`, { params: payload });
    return res.data;
};
export const getaddressListApi = async (payload) => {
    const res = await axiosInstance.get(`api/admin/getaddressList`, { params: payload });
    return res.data;
};

//purchase
export const postPurchaseApi = async (payload) => {
    const res = await axiosInstance.post('api/account/addPurchaseInvoice', payload);
    return res.data;
};
export const postPurchasereturnApi = async (payload) => {
    const res = await axiosInstance.post('api/catalog/addpurchasereturn', payload);
    return res.data;
};

export const getpurchaseList = async (payload) => {
    const res = await axiosInstance.get(`api/account/getPurchaseInvoiceList`, { params: payload });
    return res.data;
};
export const purchasereturnList = async (payload) => {
    const res = await axiosInstance.get(`api/catalog/purchasereturnList`, { params: payload });
    return res.data;
};
export const getpurchaseById = async (id) => {
    const res = await axiosInstance.get(`api/account/getPurchaseInvoiceById/${id}`);
    return res.data;
};


export const getCustomerByunitId = async (id) => {
    const res = await axiosInstance.get(`api/admin/getCustomerByunitId/${id}`);
    return res.data;
};


export const getstocktransferById = async (id) => {
    const res = await axiosInstance.get(`api/catalog/getstocktransferById/${id}`);
    return res.data;
};
export const poststocktransferapi = async (payload) => {
    const res = await axiosInstance.post('api/catalog/addstocktransfer', payload);
    return res.data;
};
export const poststockreceive = async (payload) => {
    const res = await axiosInstance.post('api/catalog/stockreceive', payload);
    return res.data;
};

export const getstocktransferList = async (payload) => {
    const res = await axiosInstance.get(`api/catalog/stocktransferList`, { params: payload });
    return res.data;
};
export const stockInvoiceApi = async (payload) => {
    const res = await axiosInstance.post('/api/catalog/printTransferInvoice', payload);
    return res.data;
};



export const getCustomerApiBySearch = async (payload) => {
    const res = await axiosInstance.get(`api/admin/getCustomerList?search=${payload}&page=1&limit=10`);
    return res.data;
};

export const getCustomerByIdApi = async (id) => {
    const res = await axiosInstance.get(`api/admin/getCustomerById/${id}`);
    return res.data;
};
export const updateCustomerApi = async (payload) => {
    const res = await axiosInstance.put(`api/admin/updateCustomer/${payload.id}`, payload);
    return res.data;
};

//Assets
// Asset Master
export const getAssetMasterlistApi = async (payload) => {
    const res = await axiosInstance.get(`api/account/getAssetCatalogList`, { params: payload });
    return res.data;
};
export const postAssetMasterApi = async (payload) => {
    const res = await axiosInstance.post('api/account/addAssetCatalog', payload);
    return res.data;
};
export const updateAssetMasterApi = async (payload) => {
    const res = await axiosInstance.put(`api/account/updateLedgerById/${payload.id}`, payload);
    return res.data;
};
export const getAssetMasterByIdApi = async (id) => {
    const res = await axiosInstance.get(`api/account/getAssetCatalogById/${id}`);
    return res.data;
};
//Asset Inventory
export const getAssetInventorylistApi = async (payload) => {
    const res = await axiosInstance.get(`api/account/getAssetInventoryList`, { params: payload });
    return res.data;
};
export const getAssetInvoiceApi = async (payload) => {
    const res = await axiosInstance.get(`api/account/getAssetInvoiceList`, { params: payload });
    return res.data;
};
export const postAssetInventoryApi = async (payload) => {
    const res = await axiosInstance.post('api/account/addAssetInventory', payload);
    return res.data;
};
export const getAssetInventoryByIdApi = async (id) => {
    const res = await axiosInstance.get(`api/account/getAssetInventoryById/${id}`);
    return res.data;
};
export const getAssetByInventoryIdApi = async (id) => {
    const res = await axiosInstance.get(`api/account/getAssetByInventoryId/${id}`);
    return res.data;
};
export const postAssetAllocationApi = async (payload) => {
    const res = await axiosInstance.post('api/account/addAssetAllocation', payload);
    return res.data;
};
export const getAssetAllocationlistApi = async (payload) => {
    const res = await axiosInstance.get(`api/account/getAssetAllocationList`, { params: payload });
    return res.data;
};
//Accounts

export const postLedgerApi = async (payload) => {
    const res = await axiosInstance.post('api/account/addLedger', payload);
    return res.data;
};
export const updateLedgerApi = async (payload) => {
    const res = await axiosInstance.put(`api/account/updateLedgerById/${payload.id}`, payload);
    return res.data;
};
export const getLedgerByIdApi = async (id) => {
    const res = await axiosInstance.get(`api/account/getLedgerById/${id}`);
    return res.data;
};
// ---useTransactions--
export const getTransactionlistApi = async (payload) => {
    const res = await axiosInstance.get(`api/account/transactions`, { params: payload });
    return res.data;
};
export const postTransactionApi = async (payload) => {
    const res = await axiosInstance.post('api/account/addtransactions', payload);
    return res.data;
};
export const updateTransactionApi = async (payload) => {
    const res = await axiosInstance.put(`api/account/addtransactions/${payload.id}`, payload);
    return res.data;
};
export const getTransactionByIdApi = async (id) => {
    const res = await axiosInstance.get(`api/account/gettransactionsById/${id}`);
    return res.data;
};
export const getTransactionVoucherApi = async (ledger_id, vouchertypeid, payload) => {
    const res = await axiosInstance.get(`api/account/getvoucherno/${ledger_id}/${vouchertypeid}`, { params: payload });
    return res.data;
};


//search
export const postAddsearch = async (payload) => {
    const res = await axiosInstance.post('/api/cms/addSearchKeyword', payload);
    return res.data;
};
export const getSearchListapi = async (payload) => {
    const res = await axiosInstance.get(`api/cms/getAllSearchKeywords`, { params: payload });
    return res.data;
};
export const getsearchByIdApi = async (id) => {
    const res = await axiosInstance.get(`api/cms/getSearchById/${id}`);
    return res.data;
};
export const updateSearchApi = async (payload) => {
    const res = await axiosInstance.put(`api/cms/updateSearchById/${payload.id}`, payload);
    return res.data;
};


//hris
export const getDepartmentApi = async (payload) => {
    const res = await axiosInstance.get(`api/hris/getDepartment`, {params : payload});
    return res.data;
};
export const getDesignationApi = async () => {
    const res = await axiosInstance.get(`api/hris/getDesignation`);
    return res.data;
};
export const getLocation = async () => {
    const res = await axiosInstance.get(`api/hris/getLocation`);
    return res.data;
};
export const poststaff = async (payload) => {
    const res = await axiosInstance.post(`api/hris/addstaff`, payload);
    return res.data;
};
export const postaddAttendance = async (payload) => {
    const res = await axiosInstance.post(`api/hris/addAttendance`, payload);
    return res.data;
};
export const poststaffwages = async (payload) => {
    const res = await axiosInstance.post(`api/hris/addstaffWage`, payload);
    return res.data;
};
export const poststaffloan = async (payload) => {
    const res = await axiosInstance.post(`api/hris/addLoan`, payload);
    return res.data;
};
export const getStaffById = async (id) => {
    const res = await axiosInstance.get(`/api/hris/getStaffById/${id}`);
    return res.data;
};
export const getStaffWageList = async (id) => {
    const res = await axiosInstance.get(`/api/hris/getStaffWagesByStaffId/${id}`);
    return res.data;
};
export const getLoanById = async (id) => {
    const res = await axiosInstance.get(`/api/hris/getLoanById/${id}`);
    return res.data;
};
export const getLoanList = async (id) => {
    const res = await axiosInstance.get(`/api/hris/getLoanList/${id}`);
    return res.data;
};
export const getHolidayList = async (id) => {
    const res = await axiosInstance.get(`/api/hris/getHolidayList`);
    return res.data;
};

export const getComponentList = async (id) => {
    const res = await axiosInstance.get(`/api/hris/getComponentList?component_type=${id}`);
    return res.data;
};

export const getStaffList = async (payload) => {
    const res = await axiosInstance.get(`api/hris/getStaffList`, { params: payload });
    return res.data;
};
export const getAttendanceList = async (payload) => {
    const res = await axiosInstance.get(`api/hris/getAttendanceList`, { params: payload });
    return res.data;
};
export const deleteWage = async (id) => {
    const res = await axiosInstance.delete(`api/hris/deleteWage/${id}`);
    return res.data;
};
export const getLedgerlistApi = async (payload) => {
    const res = await axiosInstance.get(`api/account/getLedgerList`, { params: payload });
    return res.data;
};
//taxinvoice

export const posttaxinvoiceeApi = async (payload) => {
    const res = await axiosInstance.post('api/account/addInvoice', payload);
    return res.data;
};
export const customerlist = async (id) => {
    const res = await axiosInstance.get(`api/admin/getCustomerList`);
    return res.data;
};
export const getInvoiceList = async (payload) => {
    const res = await axiosInstance.get(`api/account/getInvoiceList`, { params: payload });
    return res.data;
};
export const getInvoiceById = async (id) => {
    const res = await axiosInstance.get(`api/account/getInvoiceById/${id}`);
    return res.data;
};
//
export const marketplaces = async (id) => {
    const res = await axiosInstance.get(`api/admin/marketplaces`);
    return res.data;
};
export const deleteinventory = async (payload) => {
    const res = await axiosInstance.post('/api/account/deleteinventory', payload);
    return res.data;
};
export const getProductInventoryById = async (id) => {
    const res = await axiosInstance.get(`api/account/getProductInventoryById/${id}`);
    return res.data;
};
export const postProductInventoryApi = async (payload) => {
    const res = await axiosInstance.post('api/account/addProductInventory', payload);
    return res.data;
};
export const getProductInventoryList = async (payload) => {
    const res = await axiosInstance.get(`api/account/getProductInventoryList`, { params: payload });
    return res.data;
};
export const productsearchProduct1 = async (query, purchaseid, countryid) => {
    const cid = countryid ? countryid : 1; // fallback to 1 if countryid is undefined, null, or 0
    const res = await axiosInstance.get(`api/order/searchProduct/${1}/${query}`
    );
    return res.data;
};

//orderapis
export const postOrderApi = async (payload) => {
    const res = await axiosInstance.post('/api/order/addOrder', payload);
    return res.data;
};

export const AssignDriverApi = async (payload) => {
    const res = await axiosInstance.post('/api/order/driverStatusUpdate', payload);
    return res.data;
};

export const ProvideRefundApi = async (payload) => {
    const res = await axiosInstance.post('/api/order/returnOrder', payload);
    return res.data;
};

export const commentsApi = async (payload) => {
    const res = await axiosInstance.post('/api/order/orderComments', payload);
    return res.data;
};
export const postOrderbyidApi = async (id) => {
    const res = await axiosInstance.get(`/api/order/getOrderById/${id}`);
    return res.data;
};

export const updateorder = async (payload, id) => {
    const res = await axiosInstance.put(`/api/order/updateOrder/${id}`, payload);
    return res.data;
};

export const cancleOrder = async (payload) => {
    const res = await axiosInstance.post(`/api/order/cancelOrder`, payload);
    return res.data;
};
export const orderReturnStatusUpdateApi = async (payload) => {
    const res = await axiosInstance.post(`/api/order/orderReturnStatusUpdate`, payload);
    return res.data;
};

export const getOrderApiBySearch = async (payload) => {
    const res = await axiosInstance.get(`api/order/getOrderList?search=${payload}&page=1&limit=10`);
    return res.data;
};

export const getOrderListApi = async (payload) => {
    const res = await axiosInstance.get(`api/order/getOrderList`, { params: payload });
    return res.data;
};

export const getDriverOrderListApi = async (payload) => {
    const res = await axiosInstance.get(`api/order/getdriverOrders`, { params: payload });
    return res.data;
};
export const getDriverListApi = async (payload) => {
    const res = await axiosInstance.get(`api/order/getdriverList`, { params: payload });
    return res.data;
};
export const getReturnOrderListApi = async (payload) => {
    const res = await axiosInstance.get(`api/order/getReturnOrderList`, { params: payload });
    return res.data;
};

export const getListtabsApi = async (payload) => {
    const res = await axiosInstance.get(`api/admin/getLists/order_status`);
    return res.data;
};
export const getemirateList = async (payload) => {
    const res = await axiosInstance.get(`api/order/emirateList`, { params: payload });
    return res.data;
};
export const getnationsList = async () => {
    const res = await axiosInstance.get(`api/order/nationsList`);
    return res.data;
};
export const GatewayPaymentList = async () => {
    const res = await axiosInstance.get(`api/order/getGatewayPaymentList`);
    return res.data;
};
export const getareaListApi = async (id) => {
    const res = await axiosInstance.get(`api/order/areaList/${id}`);
    return res.data;
};
export const getOrderListByIdApi = async (id) => {
    const res = await axiosInstance.get(`api/admin/getOrderListById/${id}`);
    return res.data;
};
export const getProductListBySkuapi = async (sku) => {
    const res = await axiosInstance.get(`api/catalog/getProductListBySku/${sku}`);
    return res.data;
};
export const productsearchProduct = async (query, purchaseid, countryid) => {
    const cid = countryid ? countryid : 1; // fallback to 1 if countryid is undefined, null, or 0
    const res = await axiosInstance.get(`api/order/searchProduct/${cid}/${query}`
    );
    return res.data;
};


export const selectedsearchProductApi = async (query, countryid, areaid) => {
    const res = await axiosInstance.get(`api/order/selectProduct/${query}?country_id=${countryid}&area_id=${areaid}`);
    return res.data;
};
export const selectedsupplierApi = async (countryid, supplierid) => {
    const res = await axiosInstance.get(`api/catalog/getbillno/?country_id=${countryid}&supplierid=${supplierid}`);
    return res.data;
};
export const generateInvoiceApi = async (payload) => {
    const res = await axiosInstance.post('/api/order/generateInvoice', payload);
    return res.data;
};
export const generateShippingLabel = async (payload) => {
    const res = await axiosInstance.post('/api/order/generateShippingLabel', payload);
    return res.data;
};
export const orderDoneApi = async (payload) => {
    const res = await axiosInstance.post('/api/order/orderDone', payload);
    return res.data;
};
export const ReassignDriverApi = async (payload) => {
    const res = await axiosInstance.post('/api/order/reassignDriver', payload);
    return res.data;
};

export const generatePrintInvoice = async (payload) => {
    const res = await axiosInstance.post('/api/order/generatePrintInvoice', payload);
    return res.data;
};
export const bulkStatusUpdate = async (payload) => {
    const res = await axiosInstance.post('/api/order/bulkStatusUpdate', payload);
    return res.data;
};

//

export const postgetCustomer = async (payload) => {
    const res = await axiosInstance.post('/api/order/getCustomer', payload);
    return res.data;
};
export const updateStatusApi = async (payload) => {
    const res = await axiosInstance.post(`api/order/updateStatus`, payload);
    return res.data;
};

//forgot password
export const requestOtpByEmail = async (payload) => {
    const res = await axiosInstance.post(`api/auth/forgot-password/request-otp`, payload)
    return res.data
}


export const verifyOtpByEmail = async ({ otp }) => {
    const uidHash = localStorage.getItem('uid_hash');
    if (!uidHash) {
        throw new Error('UID hash is missing in localStorage');
    }
    const response = await axiosInstance.post('/api/auth/forgot-password/verify-otp', { otp },
        {
            headers: {
                Authorization: `Bearer ${uidHash}`
            }
        }
    );
    return response.data;
};


export const resetOtpByEmail = async (payload) => {
    const uidHash = localStorage.getItem('uid_hash');
    if (!uidHash) {
        throw new Error('UID hash is missing in localStorage');
    }

    const response = await axiosInstance.post(
        '/api/auth/forgot-password/reset-password',
        payload,
        {
            headers: {
                Authorization: `Bearer ${uidHash}`
            }
        }
    );

    return response.data;
};



export const resendOtpByEmail = async () => {
    const email = localStorage.getItem('forgot_password_email');
    const uidHash = localStorage.getItem('uid_hash');

    if (!email) {
        throw new Error('Email is missing in localStorage');
    }

    if (!uidHash) {
        throw new Error('UID hash is missing in localStorage');
    }

    const response = await axiosInstance.post(
        '/api/auth/forgot-password/resend-otp',
        { email },
        {
            headers: {
                Authorization: `Bearer ${uidHash}`
            }
        }
    );

    return response.data;
}

//Country

export const getAllCountriesApi = async (payload) => {
    const res = await axiosInstance.get(`api/admin/marketplaces`, { params: payload });
    return res.data;
};

export const getAllCountriesListApi = async (payload) => {
    const res = await axiosInstance.get(`api/admin/countries`, { params: payload });
    return res.data;
};

export const getAllnationsListApi = async (payload) => {
    const res = await axiosInstance.get(`api/admin/countries?limit=1000`, { params: payload });
    return res.data;
};

export const postCountryApi = async (payload) => {
    const res = await axiosInstance.post('api/admin/addCountry', payload);
    return res.data;
};
export const updateCountryApi = async (payload) => {
    const res = await axiosInstance.put(`api/admin/updateCountry/${payload.id}`, payload);
    return res.data;
};
export const getCountryByIdApi = async (id) => {
    const res = await axiosInstance.get(`api/admin/getCountryById/${id}`);
    return res.data;
};

export const getVariantListApi = async (payload) => {
    const res = await axiosInstance.get(`api/catalog/getVariantList`, { params: payload });
    return res.data;
};

//product
export const postProductApi = async (payload) => {
    const res = await axiosInstance.post('api/catalog/addProduct', payload);
    return res.data;
};

export const postVendorProductApi = async (payload) => {
    const res = await axiosInstance.post('api/catalog/vendor/addProduct', payload);
    return res.data;
};

export const updateProductApi = async (payload) => {
    const res = await axiosInstance.put(`api/catalog/updateProduct/${payload.id}`, payload);
    return res.data;
};

export const updateVendorProductApi = async (payload) => {
    const res = await axiosInstance.put(`api/catalog/vendor/updateProduct/${payload.id}`, payload);
    return res.data;
};

export const getAllProductApi = async (payload) => {
    const res = await axiosInstance.get(`api/catalog/allProduct`, { params: payload });
    return res.data;
};

export const getAllVendorInventoryApi = async (payload) => {
    const res = await axiosInstance.get(`api/catalog/getproductinv`, { params: payload });
    return res.data;
};

export const getProductallinvApi = async (id) => {
    const res = await axiosInstance.get(`api/catalog/getProductallinv/${id}`);
    return res.data;
};

export const getProductByIdApi = async (id) => {
    const res = await axiosInstance.get(`api/catalog/getProductById/${id}`);
    return res.data;
};

export const getVendorProductByIdApi = async (id) => {
    const res = await axiosInstance.get(`api/catalog/vendor/getProductById/${id}`);
    return res.data;
};

export const getSupplierApi = async (payload) => {
    const res = await axiosInstance.get(`api/admin/getSupplierList`, { params: payload });
    return res.data;
};


export const getSupplierById = async (id) => {
    const res = await axiosInstance.get(`api/admin/getSupplierById/${id}`);
    return res.data;
};


export const updateSupplier = async (payload) => {
    const res = await axiosInstance.put(`api/admin/updateSupplier/${payload.id}`, payload);
    return res.data;
};

export const postSupplierApi = async (payload) => {
    const res = await axiosInstance.post(`api/admin/addSupplier`, payload);
    return res.data;
};

export const getUserListByGroupApi = async (payload) => {
    const res = await axiosInstance.get(`api/users/getUserListByGroup/${payload}`);
    return res.data;
};

export const getusersbygroupApi = async (payload) => {
    const res = await axiosInstance.get(`api/crm/usersbygroup`, { params: payload });
    return res.data;
};

//Coupan

export const getCoupanlistApi = async (payload) => {
    const res = await axiosInstance.get(`api/catalog/promotions`, { params: payload });
    return res.data;
};
export const postCoupanApi = async (payload) => {
    const res = await axiosInstance.post('api/catalog/addPromotion', payload);
    return res.data;
};
export const updateCoupanApi = async (payload) => {
    const res = await axiosInstance.put(`api/catalog/updatePromotion/${payload.id}`, payload);
    return res.data;
};
export const getCoupanByIdApi = async (id) => {
    const res = await axiosInstance.get(`api/catalog/getpromotionById/${id}`);
    return res.data;
};

//Emirates

export const getAllEmiratesApi = async (payload) => {
    const res = await axiosInstance.get(`api/admin/getAllEmirates`, { params: payload });
    return res.data;
};
export const postEmiratesApi = async (payload) => {
    const res = await axiosInstance.post('api/admin/addEmirates', payload);
    return res.data;
};
export const getEmiratesByIdApi = async (id) => {
    const res = await axiosInstance.get(`api/admin/getEmiratesById/${id}`);
    return res.data;
};
export const updateEmiratesApi = async (payload) => {
    const res = await axiosInstance.put(`api/admin/updateEmirates/${payload.id}`, payload);
    return res.data;
};

//Area
export const getAllAreaApi = async (payload) => {
    const res = await axiosInstance.get(`api/admin/getAllAreas`, { params: payload });
    return res.data;
};
export const postAreaApi = async (payload) => {
    const res = await axiosInstance.post('api/admin/addAreas', payload);
    return res.data;
};
export const getAreaByIdApi = async (id) => {
    const res = await axiosInstance.get(`api/admin/getAreasById/${id}`);
    return res.data;
};
export const updateAreaApi = async (payload) => {
    const res = await axiosInstance.put(`api/admin/updateAreas/${payload.id}`, payload);
    return res.data;
};

export const postImportFileApi = async (payload) => {
    const res = await axiosInstance.post('/api/catalog/importProducts', payload);
    return res.data;
};

export const postUploadFileApi = async (payload) => {
    const res = await axiosInstance.post('api/bulkUpload', payload, {
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    });
    return res.data;
};

export const changeFaqsDisplayApi = async (payload) => {
    const res = await axiosInstance.post('/api/admin/changeFaqsdisplay', payload);
    return res.data;
};

export const updateFaqsdisplayApi = async (payload) => {
    const res = await axiosInstance.post('/api/admin/updateFaqsdisplay', payload);
    return res.data;
};

export const postFaqApi = async (payload) => {
    const res = await axiosInstance.post(`api/admin/addFaqs`, payload)
    return res.data;
};

export const getFaqApi = async (payload) => {
    const res = await axiosInstance.get(`api/admin/getFaqs`, { params: payload })
    return res.data;
};

export const getFaqByIdApi = async (id) => {
    const res = await axiosInstance.get(`api/admin/getFaqs/${id}`)
    return res.data
}

export const updateFaqApi = async (payload) => {
    const res = await axiosInstance.put(`api/admin/updateFaqs/${payload.id}`, payload)
    return res.data
}


// notifications

export const getNotificationApi = async () => {
    const res = await axiosInstance.get(`api/notifications/getNotfications`)
    return res.data;
};

export const getNotficationsCountApi = async () => {
    const res = await axiosInstance.get(`api/notifications/getNotficationsCount`)
    return res.data;
};

export const markAsReadNotficationsApi = async (payload) => {
    const res = await axiosInstance.post(`api/notifications/markAsReadNotfications`, payload)
    return res.data;
};

export const postSectionProductApi = async (payload) => {
    const res = await axiosInstance.post('api/catalog/addsectionproduct', payload);
    return res.data;
};

export const getSectionProductApi = async (payload) => {
    const res = await axiosInstance.get('api/catalog/sectionproductList', { params: payload });
    return res.data;
};

export const deletesectionproductApi = async (id) => {
    const res = await axiosInstance.delete(`api/catalog/deletesectionproduct/${id}`);
    return res.data;
};

//Hris settings
export const postDepartmentApi = async (payload) => {
    const res = await axiosInstance.post('api/hris/addDepartment', payload);
    return res.data;
}
export const getDeparmentListApi = async (payload) => {
    const res = await axiosInstance.get('api/hris/getDepartment', { params: payload },);
    return res.data;
};
export const getDepartmentByIdApi = async (id) => {
    const res = await axiosInstance.get(`api/hris/getDepartmentByID/${id}`);
    return res.data;
};
export const postDesignationApi = async (payload) => {
    const res = await axiosInstance.post('api/hris/addDesignation', payload);
    return res.data;
}

export const getDesignationListApi = async (payload) => {
    const res = await axiosInstance.get('api/hris/getDesignation', { params: payload },);
    return res.data;
};
export const getDesignationByIdApi = async (id) => {
    const res = await axiosInstance.get(`api/hris/getDesignationByID/${id}`);
    return res.data;
};
//Exit Request
export const getExitRequestListApi = async (payload) => {
    const res = await axiosInstance.get(`api/hris/getExitList`, { params: payload });
    return res.data;
};
export const getExitRequestListbySatffApi = async (payload) => {
    const res = await axiosInstance.get(`api/hris/getExitByStaffID`, { params: payload });
    return res.data;
};

export const postExitRequestApi = async (payload) => {
    const res = await axiosInstance.post('api/hris/addExit', payload);
    return res.data;
}
export const postExitApprovalApi = async (payload) => {
    const res = await axiosInstance.post('api/hris/exitApproval', payload);
    return res.data;
}
export const getExitRequestByIdApi = async (id) => {
    const res = await axiosInstance.get(`api/hris/getExitByID/${id}`);
    return res.data;
};
//Leave Request
export const getLeaveRequestListApi = async (payload) => {
    const res = await axiosInstance.get(`api/hris/getLeaveList`, { params: payload });
    return res.data;
};
export const getLeaveRequeststaffListApi = async (payload) => {
    const res = await axiosInstance.get(`api/hris/getLeaveByUserID`, { params: payload });
    return res.data;
};
export const getLeaveRequestByIdApi = async (id) => {
    const res = await axiosInstance.get(`api/hris/getLeaveByID/${id}`);
    return res.data;
};
export const postLeaveRequestApi = async (payload) => {
    const res = await axiosInstance.post('api/hris/addLeave', payload);
    return res.data;
}

export const postLeaveApi = async (payload) => {
    const res = await axiosInstance.post('api/hris/addLeavev2', payload);
    return res.data;
}

export const postLeaveApprovalApi = async (payload) => {
    const res = await axiosInstance.post('api/hris/leaveApproval', payload);
    return res.data;
}

//project

export const AmenitieList = async (payload) => {
    const res = await axiosInstance.get('api/project/getAmenitieList',{ params: payload });
    return res.data;
}
export const ProjectUnitList = async (id) => {
    const res = await axiosInstance.get(`api/project/getProjectUnitList/${id}`,);
    return res.data;
}

export const StateList = async (id) => {
    const res = await axiosInstance.get(`api/admin/getStateList?limit=10000&&country_id=${id}`,);
    return res.data;
}
export const CityList = async (id) => {
    const res = await axiosInstance.get(`api/admin/getCityList?limit=10000&&state_id=${id}`,);
    return res.data;
}

export const getProjectList = async (payload) => {
    const res = await axiosInstance.get('api/project/getProjectList', { params: payload },);
    return res.data;
}
export const getUnitInventoryReport = async (project_id) => {
    const res = await axiosInstance.get(`api/project/getUnitInventoryReport/${project_id}`);
    return res.data;
}

export const getProjectschudleList = async (payload) => {
    const res = await axiosInstance.get(`api/project/getScheduleList`, { params: payload },);
    return res.data;
}
export const getunitplanList = async (payload) => {
    const res = await axiosInstance.get(`api/project/getunitplanList`, { params: payload },);
    return res.data;
}
export const ProjectChargeList = async (payload) => {
    const res = await axiosInstance.get(`api/project/getchargesList`, { params: payload },);
    return res.data;
}

export const projectUpdatesList = async (payload) => {
    const res = await axiosInstance.get(`api/project/projectUpdatesList`, { params: payload },);
    return res.data;
}
export const getdocsList = async (payload) => {
    const res = await axiosInstance.get(`api/project/getdocsList`, { params: payload },);
    return res.data;
}
export const getProjectStructuretList = async (payload) => {
    const res = await axiosInstance.get(`api/project/getstructureList`, { params: payload },);
    return res.data;
}
export const getTowerStructure = async (id) => {
    const res = await axiosInstance.get(`api/project/getProjectStructureUnits/${id}`);
    return res.data;
}
export const getpaymentplanList = async (payload) => {
    const res = await axiosInstance.get(`api/project/getpaymentplanList`, { params: payload },);
    return res.data;
}
export const projectContactList = async (payload) => {
    const res = await axiosInstance.get(`api/project/projectContactList`, { params: payload },);
    return res.data;
}
export const getAmenitieList = async (payload) => {
    const res = await axiosInstance.get('api/project/getAmenitieList', { params: payload },);
    return res.data;
}
export const postAmenites = async (payload) => {
    const res = await axiosInstance.post('api/project/addUpdateAmenitie', payload);
    return res.data;
}
export const postProject = async (payload) => {
    const res = await axiosInstance.post('api/project/addProject', payload);
    return res.data;
}
export const postProjectSchudle = async (payload) => {
    const res = await axiosInstance.post('api/project/addUpdateSchedule', payload);
    return res.data;
}
export const postunitplan = async (payload) => {
    const res = await axiosInstance.post('api/project/addUpdateunitplan', payload);
    return res.data;
}
export const postProjectCharges = async (payload) => {
    const res = await axiosInstance.post('api/project/addUpdatecharges', payload);
    return res.data;
}
export const Postdocs = async (payload) => {
    const res = await axiosInstance.post('api/project/addUpdatedocs', payload);
    return res.data;
}
export const Postpaymentplan = async (payload) => {
    const res = await axiosInstance.post('api/project/addUpdatepaymentplan', payload);
    return res.data;
}
export const postcontacts = async (payload) => {
    const res = await axiosInstance.post('api/project/addcontacts', payload);
    return res.data;
}
export const PostUnit = async (payload) => {
    const res = await axiosInstance.post('api/project/addUnit', payload);
    return res.data;
}
export const PostProjectUpdates = async (payload) => {
    const res = await axiosInstance.post('api/project/addUpdates', payload);
    return res.data;
}
export const PostProjectStructure = async (payload) => {
    const res = await axiosInstance.post('api/project/addUpdatestructure', payload);
    return res.data;
}
export const updateProject = async (id, payload) => {
    const res = await axiosInstance.put(`api/project/updateProject/${id}`, payload);
    return res.data;
}
export const getAmenitieById = async (id) => {
    const res = await axiosInstance.get(`api/project/getAmenitieById/${id}`);
    return res.data;
}
export const getUnitById = async (id) => {
    const res = await axiosInstance.get(`api/project/getUnitById/${id}`);
    return res.data;
}
export const getprojectchargesbyid = async (id) => {
    const res = await axiosInstance.get(`api/project/getchargesById/${id}`);
    return res.data;
}
export const getScheduleById = async (id) => {
    const res = await axiosInstance.get(`api/project/getScheduleById/${id}`);
    return res.data;
}
export const getpaymentplanById = async (id,customer_id=0) => {
    const res = await axiosInstance.get(`api/project/getpaymentplanById/${id}?customer_id=${customer_id}`);
    return res.data;
}
export const getpaymentplandata = async (id,customer_id=0) => {
    const res = await axiosInstance.get(`api/project/getpaymentplandata/${id}?customer_id=${customer_id}`);
    return res.data;
}
export const getupdatesById = async (id) => {
    const res = await axiosInstance.get(`api/project/getupdatesById/${id}`);
    return res.data;
}
export const getunitplanById = async (id) => {
    const res = await axiosInstance.get(`api/project/getunitplanById/${id}`);
    return res.data;
}
export const getcontactsById = async (id) => {
    const res = await axiosInstance.get(`api/project/getcontactsById/${id}`);
    return res.data;
}
export const getdocsById = async (id) => {
    const res = await axiosInstance.get(`api/project/getdocsById/${id}`);
    return res.data;
}
export const getstructureById = async (id) => {
    const res = await axiosInstance.get(`api/project/getstructureById/${id}`);
    return res.data;
}

export const getProjectUnitList = async (id) => {
    const res = await axiosInstance.get(`api/project/getProjectUnitList/${id}`);
    return res.data;
}
export const getProjectById = async (id) => {
    const res = await axiosInstance.get(`api/project/getProjectById/${id}`);
    return res.data;
}

//CUSTOMER REALESTATE
export const Postcustomerrealestate = async (payload) => {
    const res = await axiosInstance.post('api/admin/custunitMap', payload);
    return res.data;
}
export const customerrealestateList = async (payload) => {
    const res = await axiosInstance.get(`api/admin/custunitMapList`, { params: payload },);
    return res.data;
}
export const customerpaymentList = async (payload) => {
    const res = await axiosInstance.get(`api/project/getpaymentList`, { params: payload },);
    return res.data;
}

export const customerunitsearch = async (search,id) => {
    const res = await axiosInstance.get(`api/admin/custunitMapList?limit=${1000}&search=${search}&customer_id=${id}`);
    return res.data;
}

export const Postcustomerpayment = async (payload) => {
    const res = await axiosInstance.post('api/admin/customerpayment', payload);
    return res.data;
}

export const getcustunitMapById = async (id) => {
    const res = await axiosInstance.get(`api/admin/getcustunitMapById/${id}`);
    return res.data;
}

export const getpaymentstatusApi = async (id) => {
    const res = await axiosInstance.get(`api/admin/getpaymentstatus/${id}`);
    return res.data;
};

export const getCollectionReportApi = async (payload) => {
    const res = await axiosInstance.get(`api/admin/collectionReport`, { params: payload });
    return res.data;
};

// checklist
export const checklistList = async (payload) => {
    const res = await axiosInstance.get('api/crm/getCheckList', { params: payload });
    return res.data;
}

export const checklistByID = async (id) => {
    const res = await axiosInstance.get(`api/crm/getCheckListById/${id}`);
    return res.data;
}
export const postChecklist = async (payload) => {
    const res = await axiosInstance.post('api/crm/addChecklist', payload);
    return res.data;
}
export const checklistQuestionsList = async (payload) => {
    const res = await axiosInstance.get('api/crm/getCQuestionList', { params: payload, });
    return res.data;
}
export const postCheckListQuestion = async (payload) => {
    const res = await axiosInstance.post('api/crm/addCQuestion', payload);
    return res.data;
}
export const checklistQuestionAnswersList = async (payload) => {
    const res = await axiosInstance.get('api/crm/getAnswerList', { params: payload, });
    return res.data;
}
export const checklistQuestionById = async (id) => {
    const res = await axiosInstance.get(`api/crm/getCQuestionById/${id}`);
    return res.data;
}

export const postChecklistQuestionAnswer = async (payload) => {
    const res = await axiosInstance.post('api/crm/addAnswer', payload);
    return res.data;
}

export const postChecklistCategory = async (payload) => {
    const res = await axiosInstance.post('api/crm/addACategory', payload);
    return res.data;
}

export const checklistCategoryList = async (payload) => {
    const res = await axiosInstance.get('api/crm/getACategoryList', { params: payload },);
    return res.data;
}
export const deleteAnswer = async (id) => {
    const res = await axiosInstance.delete(`api/crm/deleteChecklistAnswer/${id}`);
    return res.data;
}
export const auditAnswerById = async (id) => {
    const res = await axiosInstance.get(`api/crm/getAnswerById/${id}`);
    return res.data;
}

export const auditQuestionsAnswerById = async (id) => {
    const res = await axiosInstance.get(`api/crm/getChecklistQuestionAnswerById/${id}`);
    return res.data;
}

export const postAudit = async (payload) => {
    const res = await axiosInstance.post('api/crm/addAudit', payload);
    return res.data;
}

export const postAuditDetail = async (payload) => {
    const res = await axiosInstance.post('api/crm/addAuditDetail', payload);
    return res.data;
}

export const postAuditComment = async (payload) => {
    const res = await axiosInstance.post('api/crm/addAuditComment', payload);
    return res.data;
}

export const MyAuditList = async (payload) => {
    const res = await axiosInstance.get('api/crm/getAuditList', { params: payload });
    return res.data;
}
export const getLocationList = async (search) => {
    if (!search) return [];

    const res = await axiosInstance.get("api/crm/searchLocation", {
        params: { search },
    });
    return res.data;
};


export const getUnitList = async (payload) => {
    const res = await axiosInstance.get('api/crm/getUnitList', { params: payload, });
    return res.data;
}

export const getAuditById = async (id) => {
    const res = await axiosInstance.get(`api/crm/getAuditById/${id}`);
    return res.data;
}

export const getAuditScore = async (id) => {
    const res = await axiosInstance.get(`api/crm/scoreResults/${id}`);
    return res.data;
};

export const getAuditDetailByAuditId = async (id) => {
    const res = await axiosInstance.get(`api/crm/getAuditDetailByAuditId/${id}`);
    return res.data;
};
export const startAudit = async (payload) => {
    const res = await axiosInstance.post('api/crm/auditStartApi', payload);
    return res.data;
}

export const getReportbyId = async (id) => {
    const res = await axiosInstance.get(`api/crm/generatePdf/${id}`);
    return res.data;
};

export const getAuditReport = async (payload) => {
  const res = await axiosInstance.get(`api/crm/auditReport`, { params: payload, });
  return res.data;
};
//Lead form (ira)
export const getLeadListApi = async (payload) => {
    const res = await axiosInstance.get('api/admin/getLeadCustomers', { params: payload },);
    return res.data;
};
export const postLeadApi = async (payload) => {
    const res = await axiosInstance.post('api/admin/addLeadCustomer',  payload );
    return res.data;
}
export const getCityApi = async (payload) => {
    const res = await axiosInstance.get(`api/admin/getCityList`, { params: payload });
    return res.data;
};
export const getLeadCountApi = async (payload) => {
    const res = await axiosInstance.get(`api/admin/getLeadCount`, { params: payload });
    return res.data;
};
export const getLeadByIdApi = async (id) => {
  const res = await axiosInstance.get(`api/admin/getLeadCustomerById/${id}`);
  return res.data;
};

export const getLeadLogListApi = async (payload) => {
    const res = await axiosInstance.get('api/admin/getLogList', { params: payload },);
    return res.data;
};

export const postLeadLogApi = async (payload) => {
    const res = await axiosInstance.post('api/admin/addLog',  payload );
    return res.data;
}
export const getLeadStatusCountApi = async () => {
    const res = await axiosInstance.get(`api/admin/getLeadStatusCount`);
    return res.data;
};
export const getLeadRefreshApi = async (payload) => {
    const res = await axiosInstance.get('api/admin/getLeadCustomers2');
    return res.data;
};
//Holidaylist
export const postHolidaysApi = async (payload) => {
    const res = await axiosInstance.post('api/hris/addHoliday', payload);
    return res.data;
}

export const getHolidaysListApi = async (payload) => {
    const res = await axiosInstance.get('api/hris/getHolidayList', { params: payload },);
    return res.data;
};
export const getHolidaysByIdApi = async (id) => {
    const res = await axiosInstance.get(`api/hris/getHolidayByID/${id}`);
    return res.data;
};

export const getTaskListApi = async (payload) => {
    const res = await axiosInstance.get(`api/crm/getAllTasks`, { params: payload });
    return res.data;
};

export const getTaskByIdApi = async (id) => {
    const res = await axiosInstance.get(`api/crm/getTaskById/${id}`);
    return res.data;
}

export const addTaskApi = async (payload) => {
    const res = await axiosInstance.post('api/crm/addUpdateTasks', payload);
    return res.data;
}

export const deleteTaskApi = async (id) => {
    const res = await axiosInstance.delete(`api/crm/deleteTask/${id}`);
    return res.data;
};


export const getProjectListApi = async (payload) => {
    const res = await axiosInstance.get(`api/crm/getcrmprojectList`, { params: payload });
    return res.data;
};

export const getProjectByIdApi = async (id) => {
    const res = await axiosInstance.get(`api/crm/getProjectByid/${id}`);
    return res.data;
}

export const addProjectApi = async (payload) => {
    const res = await axiosInstance.post('api/crm/addupdateproject', payload);
    return res.data;
}

export const completedTaskByIdApi = async (id) => {
    const res = await axiosInstance.get(`api/crm/getCompleteTasks/${id}`);
    return res.data;
}

export const addAgentApi = async (payload) => {
    const res = await axiosInstance.post('api/crm/addAgents', payload);
    return res.data;
}

export const addMarketingPartnerApi = async (payload) => {
    const res = await axiosInstance.post(`api/crm/addmarketingpartners`, payload);
    return res.data;
}

export const getAgentListApi = async (payload) => {
    const res = await axiosInstance.get(`api/crm/getAllAgents`, { params: payload });
    return res.data;
};

export const agentByIdApi = async (id) => {
    const res = await axiosInstance.get(`api/crm/getAgentsById/${id}`);
    return res.data;
};

export const getCPLeadCountApi = async (payload) => {
    const res = await axiosInstance.get(`api/admin/getCPLeadCount`, { params: payload });
    return res.data;
};

export const deleteAccountApi = async () => {
    const res = await axiosInstance.delete('api/users/deleteUser');
    return res.data;
};
export const getagentProjectList = async (payload) => {
    const res = await axiosInstance.get(`api/project/getProjectForAgents`, { params: payload },);
    return res.data;
}

//Change Email
export const changeEmailApi = async (payload) => {
    const res = await axiosInstance.post('/api/auth/change-email', payload)
    return res.data
}

//Enquiry Form
export const getEnquiryLeadListApi = async (payload) => {
    const res = await axiosInstance.get('api/admin/getEnquiryLeadCustomers', { params: payload },);
    return res.data;
};
export const postEnquiryLeadApi = async (payload) => {
    const res = await axiosInstance.post('api/admin/addEnquiryLeadCustomer',  payload );
    return res.data;
}
export const postAddCampaignLead = async (payload) => {
    const res = await axiosInstance.post('api/admin/addCampaignLead',  payload );
    return res.data;
}
export const getEnquiryLeadCountApi = async (payload) => {
    const res = await axiosInstance.get(`api/admin/getEnquiryLeadCount`, { params: payload });
    return res.data;
};
export const printCostSheet = async (payload) => {
    const res = await axiosInstance.post(`api/project/printCostSheet`,  payload );
    return res.data;
};
export const getEnquiryLeadByIdApi = async (id) => {
  const res = await axiosInstance.get(`api/admin/getEnquiryLeadCustomerById/${id}`);
  return res.data;
};

export const getProjectUnitPathListApi = async (id) => {
  const res = await axiosInstance.get(`api/project/getProjectUnitPathList/${id}`);
  return res.data;
};

export const getEnquiryLeadLogListApi = async (payload) => {
    const res = await axiosInstance.get('api/admin/getEnquiryLogList', { params: payload },);
    return res.data;
};

export const postEnquiryLeadLogApi = async (payload) => {
    const res = await axiosInstance.post('api/admin/addEnquiryLog',  payload );
    return res.data;
}
export const getEnquiryLeadStatusCountApi = async () => {
    const res = await axiosInstance.get(`api/admin/getEnquiryLeadStatusCount`);
    return res.data;
};
export const getEnquiryLeadStatusCountReportApi = async (payload) => {
    const res = await axiosInstance.get(`api/admin/getEnquiryLeadStatusCountReport`, { params: payload });
    return res.data;
};

export const getLast6MonthReportApi = async (payload = {}) => {
    const res = await axiosInstance.get(`api/admin/getLast6MonthReport`, { params: payload });
    return res.data;
};
export const getLeadContact24HoursPercentageApi = async (payload = {}) => {
    const res = await axiosInstance.get(`api/admin/getLeadContact24HoursPercentage`, { params: payload });
    return res.data;
};
export const projectPerformanceDashboardApi = async (payload = {}) => {
    const res = await axiosInstance.get(`api/project/projectPerformanceDashboard`, { params: payload });
    return res.data;
};
export const getdashboardAgentListApi = async (payload = {}) => {
    const res = await axiosInstance.get(`api/crm/getdashboardAgentList`, { params: payload });
    return res.data;
};


export const wbseListApi = async (payload) => {
    const res = await axiosInstance.get(`api/wbse/getWbs_elements`, { params: payload });
    return res.data;
}

export const getWbseByIdApi = async (id) => {
    const res = await axiosInstance.get(`api/wbse/getWbseById/${id}`);
    return res.data;
}

export const addUpdateWbseApi = async (payload) => {
    const res = await axiosInstance.post('api/wbse/createWbse', payload);
    return res.data;
}
export const projectBudgetBreakDownApi = async (id) => {
    const res = await axiosInstance.get(`api/wbse/projectBudgetBreakdown/${id}`);
    return res.data;
}

//warehouse
export const postWarehouseApi = async (payload) => {
    const res = await axiosInstance.post('api/catalog/addWarehouse', payload);
    return res.data;
}

export const getWarehouseListApi = async (payload) => {
    const res = await axiosInstance.get(`api/catalog/warehouselist`, { params: payload, });
    return res.data;
};

export const getWarehouseByIdApi = async (id) => {
    const res = await axiosInstance.get(`api/catalog/wareHouseByid/${id}`);
    return res.data;
};

export const postWarehouseRackApi = async (payload) => {
    const res = await axiosInstance.post('api/catalog/addWarehouseRack', payload);
    return res.data;
}

export const getWarehouseRackListApi = async (payload) => {
    const res = await axiosInstance.get(`api/catalog/warehouseRacklist`, { params: payload, });
    return res.data;
};

export const getWarehouseRackByIdApi = async (id) => {
    const res = await axiosInstance.get(`api/catalog/wareHouseRackByid/${id}`);
    return res.data;
};

export const getStockTakingListApi = async (payload) => {
    const res = await axiosInstance.get(`api/catalog/stockTakinglist`, { params: payload, });
    return res.data;
};

export const postStockApi = async (payload) => {
    const res = await axiosInstance.post('api/catalog/addStock', payload);
    return res.data;
}

export const getStockByIdApi = async (id) => {
    const res = await axiosInstance.get(`api/catalog/getStockById/${id}`);
    return res.data;
};

export const getcostsheetList = async (payload) => {
    const res = await axiosInstance.get('api/project/costSheetList', { params: payload },);
    return res.data;
}

export const postCostSheet = async (payload) => {
    const res = await axiosInstance.post('api/project/addCostSheet', payload);
    return res.data;
}

export const getCostSheetIdApi = async (id) => {
    const res = await axiosInstance.get(`api/project/CostSheetById/${id}`);
    return res.data;
};
export const addTimesheetApi = async (payload) => {
    const res = await axiosInstance.post('api/wbse/createTimesheets', payload);
    return res.data;
}
export const timesheetListApi = async (payload) => {
    const res = await axiosInstance.get(`api/wbse/getTimesheets`, { params: payload });
    return res.data;
}
// export const taskDropdownApi = async (payload) => {
//     const res = await axiosInstance.get(`api/wbse/taskdropdown`, { params: payload });
//     return res.data;
// }
export const timesheetUserListApi = async (payload) => {
    const res = await axiosInstance.get(`api/wbse/getTimesheetUsersList`, { params: payload });
    return res.data;
}
export const approveTimesheetApi = async (payload) => {
    const res = await axiosInstance.post('api/wbse/approveTimesheet', payload);
    return res.data;
}
export const createInfluencerApi = async (payload) => {
    const res = await axiosInstance.post('api/marketing/createInfluencer', payload);
    return res.data;
}

export const getInfluencerListApi = async (payload) => {
    const res = await axiosInstance.get(`api/marketing/getInfluencerList`, { params: payload });
    return res.data;
}

export const createInfluencerSowApi = async (payload) => {
    const res = await axiosInstance.post('api/marketing/createInfluencerSow', payload);
    return res.data;
}

export const getInfluencerSowListApi = async (payload) => {
    const res = await axiosInstance.get(`api/marketing/getInfluencerSowList`, { params: payload });
    return res.data;
}

export const getInfluencerByIdApi = async (id) => {
    const res = await axiosInstance.get(`api/marketing/getInfluencerById/${id}`);
    return res.data;
}

export const createUTMApi = async (payload) => {
    const res = await axiosInstance.post('api/marketing/createCampaign', payload);
    return res.data;
}

export const getUTMListApi = async (payload) => {
    const res = await axiosInstance.get(`api/marketing/getUTMList`, { params: payload });
    return res.data;
}

export const getUTMDetailApi = async (id) => {
    const res = await axiosInstance.get(`api/marketing/getUTMDetail/${id}`);
    return res.data;
}

export const addUpdateMarketSettingsApi = async (payload) => {
    const res = await axiosInstance.post('api/marketing/createsettings', payload);
    return res.data;
}
export const getMarketSettingsByIdApi = async () => {
    const res = await axiosInstance.get(`api/marketing/getsettingsById`);
    return res.data;
}

export const getCareerJobListApi =  async (payload) => {
    const res = await axiosInstance.get(`api/careerjobs/getCareerJobs`, { params : payload});
    return res.data;
}

export const addUpdateCareerJobApi = async (payload) => {
    const res = await axiosInstance.post('api/careerjobs/addCareerJob', payload);
    return res.data;
}

export const getCareerJobByIdApi = async (id) => {
    const res = await axiosInstance.get(`api/careerjobs/getCareerJobById/${id}`);
    return res.data;
}

export const CityListForJobLocationAPI = async (payload) => {
    const res = await axiosInstance.get(`api/admin/getCityList`, { params: payload });
}

export const taskDropdownApi = async (payload) => {
    const res = await axiosInstance.get(`api/wbse/taskdropdown`, { params: payload });
    return res.data;
}
export const getItemMasterListApi = async (payload) => {
    const res = await axiosInstance.get(`api/catalog/itemMasterlist`, { params: payload });
    return res.data;
};

export const getItemMasterByIdApi = async (id) => {
    const res = await axiosInstance.get(`api/catalog/itemMasterByid/${id}`);
    return res.data;
}

export const addItemMasterApi = async (payload) => {
    const res = await axiosInstance.post('api/catalog/addItemMaster', payload);
    return res.data;
}
// getLeadReportsApi
export const getLeadReportsApi = async (payload) => {
    const res = await axiosInstance.get(`api/admin/getLeadsReport`, { params: payload });
    return res.data;
};

export const getCostSheetByUnitAPI = async (id) => {
    const res = await axiosInstance.get(`api/project/costSheetByUnit/${id}`);
    return res.data;
}

export const getProjectScheduleDashboardAPI = async (id) => {
    const res = await axiosInstance.get(`api/project/getProjectScheduleDashboard/${id}`);
    return res.data;
};
export const getProjectScheduleDrilldownAPI = async (payload) => {
    const res = await axiosInstance.get(`api/project/getProjectScheduleDrilldown`, { params: payload });
    return res.data;
};

//Entity
export const addEntityApi = async (payload) => {
    const res = await axiosInstance.post(`api/admin/addUpdateEntity`, payload);
    return res.data;
}

export const getEntityListApi = async (payload) => {
    const res = await axiosInstance.get(`api/admin/getEntityList`, { params: payload });
    return res.data;
};

export const EntityByIdApi = async (id) => {
    const res = await axiosInstance.get(`api/admin/getEntityById/${id}`);
    return res.data;
};